/*    
<summary>
  This functional component "ThemeSettings" defines the props like theme to be selected for user.
  Developer:Pratiksha Sharma, Created Date:09-June-2025
</summary>
<returns>Returns JSX</returns>
*/

import React from "react";
import { FormattedMessage } from "react-intl";
import LanguageSlider from "../../../../shared-components/language-slider/language-slider";
import ChangeThemeSettings from "./components/add-edit-theme-settings";
import "./theme-setting.css";

interface IProps {
  id: number;
}

const ThemeSettings = (props: IProps) => {
  return (
    <React.Fragment>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="theme_settings" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="various_settings" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="theme_settings" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-6">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ChangeThemeSettings id={0} />

      <div className="container-fluid p-0 wrapper" style={{height: "100vh"}}>
        <div className="g-0 layout-container vertical">
          <div className="box1 bg-primary"></div>
          <div className="box2 bg-success"></div>
          <div className="box3 bg-warning"></div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ThemeSettings;
